import React from 'react';

import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';
import { connect } from 'react-redux';

import StudentReportRoute from './routes/StudentReport';
import LoginHOC from '../../components/LoginHOC';

const mapStateToProps = (state) => ({
  authedUserID: state.auth.sub || null,
  authedUser: state.auth || null,
});

export default (store) => {
  return ({
    path        : 'student-report',
    component   : LoginHOC(connect(mapStateToProps)(props => {
      let GraphQLURI = __GraphQLPublic || publicEndpoint; // eslint-disable-line no-undef
      if (props.authedUserID !== null) {
        GraphQLURI = __GraphQLProtected || protectedEndpoint; // eslint-disable-line no-undef
      }

      let ApolloNetworkInstance = createNetworkInterface({
        uri: GraphQLURI,
        opts: {
          headers: {
            'Authorization': 'Bearer ' + (props.authedUser.rawToken || 'unauthed'),
          }
        }
      });

      let ApolloClientInstance = new ApolloClient({
        networkInterface: ApolloNetworkInstance,
      });

      return (
        <ApolloProvider client={ApolloClientInstance}>
          {props.children}
        </ApolloProvider>
      );
    })),
    indexRoute  : StudentReportRoute(store),
  });
};



// WEBPACK FOOTER //
// ./src/routes/student-report/index.js